const SelectOnFocus = {
  mounted() {
    this.el.addEventListener("focus", (e) => {
      e.target.select();
    });
  },
};

export default SelectOnFocus;
